<template>
    <div style="height: 100%;display: flex;flex-direction: column;background: #F9F9F9;">
        <div style="height: 96px;padding:38px 16px 0">
            <div @click="goBack" style="line-height: 48px;display: inline-block;">
                <a-icon style="color:rgba(4, 4, 4, 1);font-size: 16px;margin-right: 11px;" type="left" />
                <span style="color:rgba(44, 54, 74, 1);font-size:15px;">数据过滤</span>
            </div>
        </div>
        <div style="flex: 1;overflow-y: auto;position: relative;padding-bottom: 24px;">
            <div style="padding:0 16px">
                <div style="color:rgba(44, 54, 74, 1);font-size: 15px;font-weight: bold;">输入内容</div>
                <div style="margin-top:12px">
                    <a-textarea placeholder="请输入" v-model.trim="dataValue" style="min-height: 200px;border: 1px solid rgba(121, 136, 155, 0.3);resize: none;" />
                </div>
                <div style="margin-top:16px;color:rgba(44, 54, 74, 1);font-size: 15px;font-weight: bold;">号码结果</div>
                <div style="padding:12px 16px;background:#fff;margin-top: 12px;">

                    <div class="value-data" style="height: 204px;background: #fff;border-radius: 8px;padding:12px 16px;overflow-y: auto;">
                        <div v-for="(item,index) in phoneList" :key="index">{{ item }}</div>
                    </div>
                </div>
                <div v-if="phoneList.length!=0" style="margin-top:12px;">
                    <a-button @click="copyPhones">复制</a-button>
                </div>
            </div>
        </div>
        <div style="position: fixed;height: 40px;width:100%;left:0;bottom:20px;padding: 0 16px;">
            <div @click="sureFilter" style="width:100%;height: 40px;border-radius: 8px;box-shadow: 2px 2px 19px 0px rgba(66, 223, 228, 0.2);text-align: center;line-height: 40px;background: rgba(66, 223, 228, 1);color:#fff;font-size: 15px;">
                <span>过滤</span>
            </div>
        </div>
    </div>
</template>
  
<script>
    export default {
        name: 'MobileSend',
        props: {
            msg: String
        },
        data() {
            return {
                dataValue: '',
                phoneList: []
            } 
        },

        methods: {
            goBack() {
                this.$router.push("/MobileRecord")
            },
            sureFilter() {
                // ✅ 1️⃣ 用非数字切割
                const digitBlocks = this.dataValue.split(/\D+/)

                const result = new Set()

                // ✅ 2️⃣ 对每一段数字做滑动窗口
                digitBlocks.forEach(block => {
                    if (block.length < 11) return

                    for (let i = 0; i <= block.length - 11; i++) {
                        const phone = block.substr(i, 11)

                        // ✅ 3️⃣ 严格手机号校验
                        if (/^1[3-9]\d{9}$/.test(phone)) {
                            result.add(phone)
                        }
                    }
                })

                // ✅ 4️⃣ 输出数组
                this.phoneList = Array.from(result)
            },
            copyPhones () {
                const text = this.phoneList.join('\n')

                // ✅ 优先使用现代 API
                if (navigator.clipboard && window.isSecureContext) {
                    navigator.clipboard.writeText(text).then(() => {
                        this.$message && this.$message.success('复制成功')
                    }).catch(() => {
                        this.fallbackCopy(text)
                    })
                } else {
                    // ✅ 兼容方案
                    this.fallbackCopy(text)
                }
            },
            fallbackCopy (text) {
                const textarea = document.createElement('textarea')
                textarea.value = text
                textarea.readOnly = true
                textarea.style.position = 'fixed'
                textarea.style.left = '-9999px'
                document.body.appendChild(textarea)

                textarea.select()
                document.execCommand('copy')

                document.body.removeChild(textarea)
                this.$message && this.$message.success('复制成功')
            }
        },
        mounted: function() {
           
        }
    }
</script>

<style scoped lang="less">
    .mine-share{
        display: inline-block;
        width: 126px;
        height:28px;
        background: #E8E9EC;
        border-radius: 8px;
        padding: 3px;
        span{
            display: inline-block;
            height: 22px;
            line-height: 22px;
            width: 60px;
            text-align: center;
            color: rgba(103, 110, 125, 1);
            font-size: 12px;
        }
        span.active{
            background: #fff;
            border-radius: 6px;
            color: rgba(44, 54, 74, 1);
            font-size: 12px;
            font-weight: bold;
        }
    }
</style>
  